export const set = <T extends object, K extends keyof T>(
    object: T,
    pathParts: string[],
    value: any,
) => {
    if (!object || typeof object !== 'object' || pathParts.length === 0) {
        return;
    }
    const k = pathParts[0] as K;
    if (pathParts.length === 1) {
        object[k] = value;
        return;
    }
    const rest = pathParts.slice(1);

    object[k] = object[k] || ({} as T[K]);
    set(object[k] as object, rest, value);
    return;
};

export const get = (object: any, pathParts: string[]): unknown => {
    let current = object;
    for (let i = 0; i < pathParts.length; i++) {
        current = current?.[pathParts[i]];
    }
    return current;
};
